import { ButtonItemsStylesRenderer } from "./button-items-styles-renderer";
import { DefaultItemsStyleRenderer } from "./default-items-style-renderer";
import { DividedItemsStyleRenderer } from "./divided-items-style-renderer";
import { OverlinedItemsStyleRenderer } from "./overlined-items-style-renderer";
import { IMenuStyleData, MenuItemsLayoutType } from "@pageBuilder/typings";
import { ElementStyleService } from "../../../../services/element-style.service";

export class CommonMenuItemsStylesRenderer {

    public defaultItemsStylesRenderer: DefaultItemsStyleRenderer;
    public dividedItemsStyleRenderer: DividedItemsStyleRenderer;
    public overlinedItemsStylesRenderer: OverlinedItemsStyleRenderer;
    public buttonItemsStylesRenderer: ButtonItemsStylesRenderer;

    public constructor(private readonly styleService: ElementStyleService) {
        this.defaultItemsStylesRenderer = new DefaultItemsStyleRenderer(styleService);
        this.dividedItemsStyleRenderer = new DividedItemsStyleRenderer(styleService);
        this.overlinedItemsStylesRenderer = new OverlinedItemsStyleRenderer(styleService);
        this.buttonItemsStylesRenderer = new ButtonItemsStylesRenderer(styleService);
    }

    public render(element: HTMLElement, style: IMenuStyleData): void {
        switch (style.itemsLayoutType) {
            case "default": {
                this.defaultItemsStylesRenderer.render(element, style);
                break;
            }
            case "divided": {
                this.dividedItemsStyleRenderer.render(element, style);
                break;
            }
            case "overlined": {
                this.overlinedItemsStylesRenderer.render(element, style);
                break;
            }
            case "button": {
                this.buttonItemsStylesRenderer.render(element, style);
                break;
            }
            default: {
                throw("Style renderer doesn`t exist");
            }
        }
    }

    private getItemsLayoutType(element: HTMLElement): MenuItemsLayoutType {
        const list = element.querySelector(`ul.root`);

        if (!list) {
            return "default";
        }

        if (list.classList.contains("default")) {
            return "default";
        } else if (list.classList.contains("divided")) {
            return "divided";
        } else if (list.classList.contains("overlined")) {
            return "overlined";
        } else if (list.classList.contains("button")) {
            return "button";
        }

        return "default";
    }

    public getStylesSelectors(element: HTMLElement, itemsLayouType: MenuItemsLayoutType | null = null): string[] {
        if (!itemsLayouType) {
            itemsLayouType = this.getItemsLayoutType(element);
        }

        const id = element.id;

        switch (itemsLayouType) {
            case "default": {
                return this.defaultItemsStylesRenderer.getStylesSelectors(id);
            }
            case "divided": {
                return this.dividedItemsStyleRenderer.getStylesSelectors(id);
            }
            case "overlined": {
                return this.overlinedItemsStylesRenderer.getStylesSelectors(id);
            }
            case "button": {
                return this.buttonItemsStylesRenderer.getStylesSelectors(id);
            }
            default: {
                throw("Style renderer doesn`t exist");
            }
        }
    }

    public clearStyles(element: HTMLElement, itemsLayouType: MenuItemsLayoutType | null = null): void {
        const selectors = this.getStylesSelectors(element, itemsLayouType);
        selectors.forEach(selector => this.styleService.clearStyle(element, selector));
    }

}
